import React, { Component } from "react";
import { connect } from "react-redux";

class Header extends Component {

  render() {
    if (!this.props.configStorage.hasHeader()) return null;
    let header = this.props.mandantStorage.header;
    return (
      <div className="if6_outer if6_header" role="region" title="Kopfzeile">
        <div className="logo parbase" id="header_Logo">
          <a title={header.headertitle} href={header.headerLink}>
            {this.props.configStorage.getMandantLogo() &&
              <img
                alt={header.headeralt1}
                src={this.props.configStorage.getLogoImageUrl()}
              />
            }
          </a>
        </div>
      </div>
    );
  }
}
export default connect(store => {
  return {
    configStorage: store.configStorage,
    mandantStorage: store.mandantStorage
  };
})(Header);
